import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs';

@Component({
  selector: 'app-flex-job-info',
  templateUrl: './flex-job-info.component.html',
  styleUrls: ['./flex-job-info.component.scss'],
})
export class FlexJobInfoComponent implements OnInit {
  // The query parameters to include when navigating to the Last Minute form page.
  queryParametersToLMJ = {};

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit() {
    this.activatedRoute.queryParams.pipe(take(1)).subscribe((queryParams) => {
      this.queryParametersToLMJ = queryParams || {};
    });
  }
}
